import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-common-banner-section',
  templateUrl: './common-banner-section.component.html',
  styleUrls: ['./common-banner-section.component.less']
})
export class CommonBannerSectionComponent implements OnInit {

  @Input() headerText: string;

  constructor() { }

  ngOnInit() {
  }

}
